import PropTypes from 'prop-types';
import React, { memo, useMemo, useCallback } from 'react';
import { NavLink, useHistory, useLocation, useRouteMatch } from 'react-router-dom';

function MenuItem({ to, text, exact, icon, iconGradient, external }) {
  const history = useHistory();
  const location = useLocation();

  const isActivePage = Array.isArray(to)
    ? to.some((path) => location.pathname.startsWith(path))
    : // eslint-disable-next-line react-hooks/rules-of-hooks
      useRouteMatch({ path: to, exact });

  const handleNavigate = useCallback(() => (external ? window.open(to, '_blank') : history.push(to)), [external, history, to]);

  const iconClasses = useMemo(() => `${icon}${iconGradient ? ` icon-gradient ${iconGradient}` : ''}`, [icon, iconGradient]);

  return (
    <li className={`sidebar-menu--item ${isActivePage ? 'active' : ''}`} onClick={handleNavigate}>
      {external ? (
        <a>
          <i className={iconClasses} />
          <span className="sidebar-menu--item-text">{text}</span>
        </a>
      ) : (
        <NavLink to={Array.isArray(to) ? to[0] : to} exact={exact}>
          <i className={iconClasses} />
          <span className="sidebar-menu--item-text">{text}</span>
        </NavLink>
      )}
    </li>
  );
}

MenuItem.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  text: PropTypes.string.isRequired,
  external: PropTypes.bool,
  exact: PropTypes.bool,
  icon: PropTypes.string,
  iconGradient: PropTypes.string,
};

export default memo(MenuItem);
